import React, { useState } from 'react'
import { Grid, TextField, Typography, Button, Radio, RadioGroup, Checkbox, Link, Stack, Autocomplete } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormGroup from '@mui/material/FormGroup';
import { checkboxClasses } from '@mui/material/Checkbox';
import colors from '../../colors'
import * as yup from 'yup'
import { useFormik } from 'formik';
import { selectRegistrationState, decrementCurrentRegistrationStep, setAddress, setBirthdate, setCity, setFathersName, setGender, setShouldFacePhiApply } from '../../../features/registration/registrationSlice'
import { selectGlobalDataState } from '../../../features/global/globalDataSlice'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { sendGeneralRequest } from '../../../features/generalRequest';
import moment from 'moment';
import { LocalizationProvider } from '@mui/lab';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { selectTermsAndConditionsState } from '../../../features/termsAndConditions/termsAndConditionsSlice'
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';
import { selectLoginState } from '../../../features/login/loginSlice';
import CountrySelect from '../../general/uanataca/CountrySelect';

export const UpgradeAccountToIndividualFifthStep = () => {

    const registrationSliceState = useSelector(selectRegistrationState)
    const loginSlice = useSelector(selectLoginState)
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const termsAndConditionsSliceState = useSelector(selectTermsAndConditionsState)
    const dispatch = useDispatch()
    const [countryID, setCountryID] = useState('AL');
    const [residence, setResidence] = useState('AL');

    const albanianCities = [
        "Berat",
        "Dibër",
        "Durrës",
        "Elbasan",
        "Fier",
        "Gjirokastër",
        "Korçë",
        "Kukës",
        "Lezhë",
        "Shkodër",
        "Tiranë",
        "Vlorë",
    ];

    const validationSchema = yup.object({
        fathersName: yup
            .string(texts["message-invalid-fathers-name"])
            .required(texts["message-invalid-fathers-name"]),
        city: yup
            .string(texts["message-invalid-city"])
            .required(texts["message-invalid-city"]),
        address: yup
            .string(texts["message-invalid-address"])
            .required(texts["message-invalid-address"]),
        gender: yup
            .string(texts["message-invalid-gender"])
            .required(texts["message-invalid-gender"]),
        birthDate: yup
            .string(texts["message-invalid-birthdate"])
            // .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
            //     message:'Datelindja duhet te jete ne formatin DD/MM/YYYY'
            // })
            .required(texts["message-invalid-birthdate"])
            .nullable(),
        idTC: yup
            .bool()
            .oneOf([true], texts["message-invalid-terms-and-conditions"]),
        ...(countryID !== 'AL') &&
        {
            taxNumber: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
            secondaryAddress: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
        }
    })

    const handleCountryChange = (selectedCountry) => {
        setCountryID(selectedCountry.shortCode)
    }

    const handleResidence = (val) => {
        setResidence(val.shortCode)
    }

    const parseDate = (input) => {
        const parsedDate = moment(input, 'DD/MM/yyyy');
        const formattedDate = parsedDate.format('MM/DD/YYYY');
        return formattedDate
    }
    const removePrefix = (base64String) => {
        if (base64String.startsWith('data:image/jpeg;base64,')) {
            return base64String.slice('data:image/jpeg;base64,'.length);
        }
        return base64String;
    };

    const modifiedBase64 = removePrefix(registrationSliceState.idPictureBase64);

    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            city: '',
            address: '',
            fathersName: '',
            birthDate: '',
            gender: '',
            idTC: false,
            idPrivacyPolicy: '',
            ext: registrationSliceState.idPictureExtension,
            base64Content: modifiedBase64,
            idNumber: registrationSliceState.idNumber,
            expiryDate: registrationSliceState.idExpiryDate,
            accountType: registrationSliceState.accountType,
            pep: '1',
            income: '',
            secondaryAddress: '',
            taxNumber: ''
            //identificationDocumentType:"N/A"
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            //var splitFullName = values.fullName.split(/(\s+)/);
            //dispatch(setToken(registrationSliceState.token))
            dispatch(sendGeneralRequest({
                request: {
                    _request: {
                        ...values, idTC: termsAndConditionsSliceState.idTC,
                        idPrivacyPolicy: termsAndConditionsSliceState.idPrivacyPolicy,
                        isPep: values.pep === '0',
                        nationality: countryID,
                        residence: residence,
                        birthDate: loginSlice.isManualRegistration ? moment(values.birthDate).format('DD/MM/yyyy') : values.birthDate,
                    }
                },
                baseUrlKey: 'auth',
                endpoint: 'UpgradeFromBasicToIPEIndividual'
            }))
        }
    })


    React.useEffect(() => {
        dispatch(sendGeneralRequest({ request: { _request: { TypeOfAccount: registrationSliceState.accountType } }, baseUrlKey: 'auth', endpoint: 'GetTermsAndConditions' }))
    }, [])

    const onBackButtonClick = () => {
        dispatch(setFathersName(formik.values.fathersName))
        dispatch(setAddress(formik.values.address))
        dispatch(setCity(formik.values.city))
        dispatch(setBirthdate(formik.values.birthDate))
        dispatch(setGender(formik.values.gender))
        dispatch(decrementCurrentRegistrationStep())
    }

    React.useEffect(() => {
        formik.setFieldValue('fathersName', registrationSliceState.fathersName)
        formik.setFieldValue('address', registrationSliceState.address)
        formik.setFieldValue('city', registrationSliceState.city)
        formik.setFieldValue('birthDate', registrationSliceState.birthDate)
        formik.setFieldValue('gender', registrationSliceState.gender)
    }, [registrationSliceState.fathersName, registrationSliceState.address, registrationSliceState.city, registrationSliceState.birthDate, registrationSliceState.gender])

    const useStyles = makeStyles({
        mainGrid: {
            width: '60%',
            paddingLeft: '9.5%',
            '@media (max-width: 899px )': { width: '90%' }
        },
        fieldTitle: {
            color: colors.orange,
            fontSize: '1.2rem',
            fontFamily: 'GerberaMedium'
        },
        textField: {
            width: '15vw',
            '@media (max-width: 899px)': { width: '50vw' }
        },
        button: {
            background: colors.gradientOrange,
            color: colors.white,
            width: '12%',
            fontFamily: 'GerberaBold',
            textTransform: 'none',
            fontSize: '1rem',
            '@media (max-width: 899px)': { width: '40%' }
        },
        link: {
            color: colors.orange,
            textDecorationColor: colors.orange,
            fontFamily: 'GerberaLight',
            "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' }
        }
    })

    const classes = useStyles()

    return (
        <form onSubmit={formik.handleSubmit} >
            <Grid container justifyContent='center' width={'100%'}>
                <Grid container item className={classes.mainGrid}>
                    <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-fathers-name-basic"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="fathersName" name="fathersName" onChange={formik.handleChange} value={formik.values.fathersName} error={formik.touched.fathersName && Boolean(formik.errors.fathersName)} helperText={formik.touched.fathersName && formik.errors.fathersName} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid item md={6} xs={12} mb={8} >
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-residence"]}</Typography>
                        </Grid>
                        <CountrySelect onCountryChange={handleResidence} isNotDisabled={true} />
                    </Grid>

                    {(residence !== 'AL') ? (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-city"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="city" name="city" onChange={formik.handleChange} value={formik.values.city} error={formik.touched.city && Boolean(formik.errors.city)} helperText={formik.touched.city && formik.errors.city} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                        </Grid>) :
                        (
                            <Grid container item md={6} xs={12} mb={8} flexDirection="column">
                                <Grid container item justifyContent="flex-start" mb={2}>
                                    <Typography className={classes.fieldTitle} variant="h6">
                                        {texts["title-registration-city"]}
                                    </Typography>
                                </Grid>
                                <Autocomplete
                                    sx={{ width: '200px' }}
                                    id="city"
                                    options={albanianCities}
                                    value={formik.values.city || ""}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue("city", newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            color='warning'
                                            label={texts["title-registration-city"]}
                                            error={formik.touched.city && Boolean(formik.errors.city)}
                                            helperText={formik.touched.city && formik.errors.city}
                                            className={classes.textField}
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                    <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10} >
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-address"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="address" name="address" onChange={formik.handleChange} value={formik.values.address} error={formik.touched.address && Boolean(formik.errors.address)} helperText={formik.touched.address && formik.errors.address} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10} >
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-birthdate"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'>
                            {/* <TextField id="birthDate" name="birthDate"  placeholder="DD/MM/YYYY" onChange={formik.handleChange} value={formik.values.birthDate} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} helperText={formik.touched.birthDate && formik.errors.birthDate} color="warning" variant="standard" sx={{width:'60%'}} /> */}
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    {loginSlice.isManualRegistration ? (
                                        <DesktopDatePicker
                                            inputFormat="dd/MM/yyyy"
                                            openTo="day"
                                            views={['day', 'month', 'year']}
                                            value={formik.values.birthDate}
                                            id='birthDate' name='birthDate' onChange={val => { formik.setFieldValue("birthDate", val); }} color={'warning'}
                                            renderInput={(params) =>
                                                <TextField variant="standard" id='birthDate' name='birthDate' label='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate} className={classes.textField} {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} />}
                                        />) :
                                        <DesktopDatePicker
                                            inputFormat="dd/MM/yyyy"
                                            openTo="day"
                                            views={['day', 'month', 'year']}
                                            value={parseDate(formik.values.birthDate)}
                                            id='birthDate' name='birthDate' onChange={val => { formik.setFieldValue("birthDate", val); }} color={'warning'}
                                            renderInput={(params) =>
                                                <TextField variant="standard" id='birthDate' name='birthDate' label='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate} className={classes.textField} {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} />}
                                        />}
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12} mb={8} >
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography className={classes.fieldTitle} variant="h6">{texts["nationality"]}</Typography>
                        </Grid>
                        <CountrySelect onCountryChange={handleCountryChange} />
                    </Grid>
                    <Grid item md={6} xs={12} mb={8}>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography className={classes.fieldTitle} variant="h6">PEP <span style={{ fontSize: '12px' }}>(Person i ekspozuar politikisht)</span></Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start'>
                            <RadioGroup name="pep" row aria-labelledby="demo-row-radio-buttons-group-label" value={formik.values.pep} onChange={formik.handleChange}>
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={'Po'} control={<Radio color='warning' value={0} />} label={texts["yes"]} />
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={'Jo'} control={<Radio color='warning' value={1} checked={formik.values.pep === '1'} />} label={texts["no"]} />
                            </RadioGroup>
                        </Grid>
                        {formik.touched.pep && <FormHelperText error>{formik.errors.pep}</FormHelperText>}
                    </Grid>
                    {(countryID !== 'AL') && (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["secondary-address"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="secondaryAddress" name="secondaryAddress" label={texts["street/building/apartment"]} onChange={formik.handleChange} value={formik.values.secondaryAddress} error={formik.touched.secondaryAddress && Boolean(formik.errors.secondaryAddress)} helperText={formik.touched.secondaryAddress && formik.errors.secondaryAddress} color={'warning'} variant="standard" className={classes.textField}
                                required={(countryID !== 'AL')} /></Grid>
                        </Grid>
                    )}
                    {(countryID !== 'AL') && (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["tax-number"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="taxNumber" name="taxNumber" onChange={formik.handleChange} value={formik.values.taxNumber} error={formik.touched.taxNumber && Boolean(formik.errors.taxNumber)} helperText={formik.touched.taxNumber && formik.errors.taxNumber} color={'warning'} variant="standard" className={classes.textField}
                                required={(countryID !== 'AL')} /></Grid>
                        </Grid>
                    )}
                    <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["income"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="income" name="income" onChange={formik.handleChange} value={formik.values.income} label={texts["job/savings/rent"]} error={formik.touched.income && Boolean(formik.errors.income)} helperText={formik.touched.income && formik.errors.income} color={'warning'} variant="standard" className={classes.textField} required /></Grid>
                    </Grid>

                    <Grid container item md={6} xs={12} flexDirection='column' >
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-gender"]}</Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start' >
                            <RadioGroup name="gender" row aria-labelledby="demo-row-radio-buttons-group-label" value={formik.values.gender} onChange={formik.handleChange}>
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={!loginSlice.isManualRegistration ? 'M' : 'Mashkull'} control={<Radio color='warning' value={0} checked={(!loginSlice.isManualRegistration && registrationSliceState.gender === 'M') || (loginSlice.isManualRegistration && formik.values.gender === '0')} />} label={texts["gender-male"]} />
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={!loginSlice.isManualRegistration ? 'F' : 'Femër'} control={<Radio color='warning' value={1} checked={(!loginSlice.isManualRegistration && registrationSliceState.gender === 'F') || (loginSlice.isManualRegistration && formik.values.gender === '1')} />} label={texts["gender-female"]} />
                            </RadioGroup>
                        </Grid>
                        {formik.touched.gender && <FormHelperText error>{formik.errors.gender}</FormHelperText>}
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column' mt={5}>
                        <FormGroup>
                            <FormControlLabel onChange={formik.handleChange} control={<Checkbox id="idTC" name="idTC" checked={formik.values.idTC} sx={{ [`&.${checkboxClasses.checked}`]: { color: colors.orange }, color: colors.gray }} />} 
                            label={<Typography textAlign="left" color={colors.gray} fontFamily={'GerberaLight'}>
                               {texts["terms-and-conditions-confirm"]}
                                <Link href={termsAndConditionsSliceState.termsAndConditionsUrl} target="_blank" style={{ color: colors.orange, marginRight: 5 }}><br />{texts["terms-and-conditions"]}</Link>
                                {texts["and-separator"]}
                                <Link href={termsAndConditionsSliceState.privacyUrl} target="_blank" style={{ color: colors.orange }}><br />{texts["privacy-politics"]}</Link>
                                {texts["of-ep"]}
                                </Typography>
                            } /> 
                        </FormGroup>
                        {formik.touched.idTC && <FormHelperText error>{formik.errors.idTC}</FormHelperText>}
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12} pt={6}>
                    <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' className={classes.button}>{texts["button-continue"]}</Button>
                </Grid>
                <Grid item md={12} xs={12} pt={'0.8%'}>
                    <Link disabled={registrationSliceState.isLoading ? true : false} className={classes.link} onClick={onBackButtonClick} component='button' variant='body2'>{texts["button-back"]}</Link>
                </Grid>
            </Grid>
        </form>
    )
}
export default UpgradeAccountToIndividualFifthStep